import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'
import { getAllRoles } from '../../../api/user/list-all-roles'

/* Initial state of the slice */
export const initialState = {
  isFetchingRoles: false,
  roles: [],
  fetchRolesError: null,
}

/* Handler for making service call to fetch all roles */
export const fetchRoles = createAsyncThunk(
  'roleManagement/fetchRoles',
  async (args, { rejectWithValue }) => {
    try {
      const response = await getAllRoles()
      return response?.data?.data?.roles
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

const viewRoleSlice = createSlice({
  name: 'viewRole',
  initialState,
  reducers: {
    resetViewRolesSlice() {
      return initialState
    },
    resetFetchRoleError(state) {
      state.fetchRolesError = null
    },
  },
  extraReducers: (builder) => {
    builder
      /* Fetching Roles */
      .addCase(fetchRoles.pending, (state) => {
        state.isFetchingRoles = true
        state.roles = []
        state.fetchRolesError = null
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.isFetchingRoles = false
        state.roles = action.payload
      })
      .addCase(fetchRoles.rejected, (state, action) => {
        state.isFetchingRoles = false
        state.fetchRolesError = action.payload
      })
      /* Action which gets triggered
         when running persistor.purge() */
      .addCase(PURGE, () => {
        return initialState
      })
  },
})

export const { resetViewRolesSlice, resetFetchRoleError } = viewRoleSlice.actions

export default viewRoleSlice.reducer
